import request from '@/utils/request1';
import { formatGetUri } from '@/utils/url';

export const COMMON_PREFIX = '/api';

export const STATIC_URL = {
  GET_LIST: `${COMMON_PREFIX}/gmrfid-service-community/admin/manager/navigationSet/getList`,
  SAVE: `${COMMON_PREFIX}/gmrfid-service-community/admin/manager/navigationSet/save`,
  UPDATE: `${COMMON_PREFIX}/gmrfid-service-community/admin/manager/navigationSet/update`,
  DELETE: `${COMMON_PREFIX}/gmrfid-service-community/admin/manager/navigationSet/delete`,
};

export function getListApi() {
  return request(`${STATIC_URL.GET_LIST}`, { method: 'GET', login: true }).then(
    (r) => r?.data,
    (error) => Promise.reject(error),
  );
}

export function saveApi(data) {
  return request(`${STATIC_URL.SAVE}`, { method: 'POST', login: true, body: data }).then(
    (r) => r?.data,
    (error) => Promise.reject(error),
  );
}

export function updateApi(params = {}) {
  return request(`${STATIC_URL.UPDATE}`, { method: 'POST', login: true, body: params }).then(
    (r) => r?.data,
    (error) => Promise.reject(error),
  );
}

export function deleteApi(params = {}) {
  return request(`${STATIC_URL.DELETE}`, { method: 'POST', login: true, body: params }).then(
    (r) => r?.data,
    (error) => Promise.reject(error),
  );
}

// 行业管理-行政区划中-编辑账号
export function updateAccountApi(params = {}) {
  return request('/api/gmrfid-service-user/admin/userOrganize/updateAccount', { method: 'POST', login: true, body: params }).then(
    (r) => r?.data,
    (error) => Promise.reject(error),
  );
}
